import { createSlice } from '@reduxjs/toolkit';

const sale = createSlice({
  name: 'sale',
  initialState: {
    saleReturns: [],
  },
  reducers: {
    setSaleReturns: (state, action) => {
      state.saleReturns = action.payload;
    },
  },
});

export const { setSaleReturns } = sale.actions;
export default sale.reducer;